import { tl } from '@doda/common/src/utils/adobeAnalyticsUtil';
import {
  AnalyticsAppThunk,
  NeededStateForAnalytics,
} from '@doda/common/src/types/analytics';

/**
 * Dispatches an analytics event when a bar graph item is clicked.
 * @param root0 - The parameters object.
 * @param root0.occupationCode - The occupation code to include in the analytics event.
 * @returns A thunk that dispatches the analytics event.
 */
export const measureClickBarGraphItem =
  <S extends NeededStateForAnalytics>({
    occupationCode,
  }: {
    occupationCode: string;
  }): AnalyticsAppThunk<S> =>
  () => {
    tl(`Occupation_graph_click_${occupationCode}`, {});
  };

/**
 * Dispatches an analytics event when the job search list link is clicked.
 * @returns A thunk that dispatches the analytics event.
 */
export const measureClickJobSearchListLink = () => () => {
  tl('Occupation_jobsearchlist_click', {});
};

/**
 * Dispatches an analytics event when the job trend link is clicked.
 * @returns A thunk that dispatches the analytics event.
 */
export const measureClickJobTrendLink = () => () => {
  tl('Occupation_jobtrend_click', {});
};

/**
 * Dispatches an analytics event when the job ranking link is clicked.
 * @returns A thunk that dispatches the analytics event.
 */
export const measureClickJobRankingLink = () => () => {
  tl('Occupation_jobranking_click', {});
};

/**
 * すべての求人を見るリンクがクリックされた時の計測
 * @param analyticsValue
 * @returns A thunk that dispatches the analytics event.
 */
export function measureJobListLink<S extends NeededStateForAnalytics>({
  analyticsValue,
}: {
  analyticsValue: string;
}): AnalyticsAppThunk<S> {
  return () => {
    tl(`Occupation_recommendlist_click_${analyticsValue}`, {});
  };
}
